import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterGuard from './router.config'
Vue.use(VueRouter)
import common from './modules/common'
import login from './modules/login' // 登录
import member from './modules/member' // member模块
import doctorAppointment from './modules/doctorAppointment' // 金牌医生预约模块
import medicineforchronic from './modules/medicineforchronic' // 线上送药模块
import allpolicy from './modules/allpolicy' // 全部保单
import queryhospital from './modules/queryhospital' // 医院查询模块
import medicalrecords from './modules/medicalrecords' // 就医记录模块
import businessprogress from './modules/businessprogress' // 业务进度查询
import claim from './modules/claim' // 自助理赔模块
import preauthorize from './modules/preauthorize' // 预授权模块
import selfpaymentamount from './modules/selfpaymentamount' // 待缴自付额
import messagecenter from './modules/messagecenter' // 消息中心
import survey from './modules/survey' // 问卷调查
import otherservice from './modules/otherservice' // 其他服务
import bankcard from './modules/bankcard' // 银行卡
import usercenter from './modules/usercenter' // 个人中心
import bxcard from './modules/bxcard' // 保险卡模块
import welfare from './modules/welfare' // 保险福利
import incrementservice from './modules/incrementservice' // 增值服务
import cashierdesk from './modules/cashierdesk' // 收银台
import fafuli from './modules/fafuli' // 发福利
import worldCup from './modules/world-cup' // 卡塔尔世界杯
import activities from './modules/activities' // 活动模块集合
import identity from './modules/identity' // 证件信息登记模块
import otherSystem from './modules/otherSystem' // 其他系统跳转页面
const routes = [
  ...common,
  ...login,
  ...member,
  ...doctorAppointment,
  ...medicineforchronic,
  ...allpolicy,
  ...queryhospital,
  ...medicalrecords,
  ...businessprogress,
  ...claim,
  ...preauthorize,
  ...selfpaymentamount,
  ...messagecenter,
  ...survey,
  ...otherservice,
  ...bankcard,
  ...usercenter,
  ...bxcard,
  ...welfare,
  ...incrementservice,
  ...cashierdesk,
  ...fafuli,
  ...worldCup,
  ...activities,
  ...identity,
  ...otherSystem
]

const router = new VueRouter({
  mode: 'history',
  base: '/m',
  routes
})

RouterGuard(VueRouter, router)

export default router
